import { useLocale, useTranslations } from 'next-intl'
import { useMemo } from 'react'

import { LUXON_STORE_TIME_HOUR_FORMAT_MAP, OPEN_HOUR_TYPE } from '@constants/constants'
import { getStoreSpecialHoursForDate } from '@lib/store-hours-utils'

type UseStoreHoursProps = Parameters<typeof getStoreSpecialHoursForDate>[0]

export const useStoreSpecialHours = (props: UseStoreHoursProps) => {
  const t = useTranslations()
  const locale = useLocale()

  return useMemo(() => {
    const specialHours = getStoreSpecialHoursForDate(props)

    return specialHours.map(({ type, dateTime, openDateTime, closeDateTime }) => ({
      type,
      dateTime,
      openDateTime,
      closeDateTime,
      dateText: dateTime.toFormat('dd MMMM yyyy', { locale }),
      openingHoursText:
        type === OPEN_HOUR_TYPE.holiday
          ? t('global.store.status-closed')
          : `${openDateTime.toFormat(LUXON_STORE_TIME_HOUR_FORMAT_MAP[locale], { locale })} - ${closeDateTime.toFormat(LUXON_STORE_TIME_HOUR_FORMAT_MAP[locale], { locale })}`
    }))
  }, [t, locale, props.date.toMillis(), props.storeHours, props.storeHours.length, props.timeZone])
}
